import { useState } from "react";
import { FaPhoneSquareAlt, FaEnvelope, FaBars, FaTimes } from "react-icons/fa";
import Logo from "../Images/Logo.png";
import { Link } from "react-router-dom";
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="flex relative z-99 items-center justify-between p-4 bg-gradient-to-r from-white to-gray-100">
      <div className="flex items-center">
        <Link to={"/"}>
          {" "}
          <img src={Logo} alt="Logo" className="h-10" />
        </Link>
      </div>

      {/* Navigation Links */}
      <ul
        className={`hidden md:flex space-x-6 lg:gap-5 text-gray-800 text-[16px] md:text-[12px] lg:text-[16px] font-[500] font-[Nunito]`}
      >
        <Link to={"/"}>
          <li className="hover:text-blue-500 cursor-pointer">Home</li>
        </Link>
        <Link to={"/aboutus"}>
          <li className="hover:text-blue-500 cursor-pointer">About Us</li>
        </Link>
        <Link to={"/services"}>
          <li className="hover:text-blue-500 cursor-pointer">Services</li>
        </Link>
        <Link to={"/partnershipwithus"}>
          <li className="hover:text-blue-500 cursor-pointer">
            Partner With Us
          </li>
        </Link>
        <Link to={"/portfolio"}>
          <li className="hover:text-blue-500 cursor-pointer">Portfolio</li>
        </Link>
        <Link to={"/blog"}>
          <li className="hover:text-blue-500 cursor-pointer">Blog</li>
        </Link>
        <Link to={"/contactus"} k>
          <li className="hover:text-blue-500 cursor-pointer">Contact Us</li>
        </Link>
      </ul>

      {/* Icons and Hamburger */}
      <div className="flex items-center space-x-4">
        <button className="p-2 border rounded-full hover:bg-gray-200">
          <a href="tel:9328920882">
            <FaPhoneSquareAlt className="text-gray-600 cursor-pointer hover:text-black transition" />
          </a>
        </button>
        <button className="p-2 border rounded-full hover:bg-gray-200">
          <a href="mailto:support@godhanitechnology.com">
            <FaEnvelope className="text-gray-600" />
          </a>
        </button>
        <div className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <FaTimes className="text-2xl text-gray-800" />
          ) : (
            <FaBars className="text-2xl text-gray-800" />
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      <ul
        className={`md:hidden absolute top-16 left-0 w-full bg-white shadow-lg rounded-b-2xl p-4 transition-all duration-300 ease-in-out 
  after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-1 after:bg-gradient-to-red from-blue-500 to-purple-500
  ${isOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}
      >
        {[
          { label: "Home", link: "/" },
          { label: "About Us", link: "/aboutus" },
          { label: "Services", link: "/services" },
          { label: "Partner With Us", link: "/partnershipwithus" },
          { label: "Portfolio", link: "/portfolio" },
          { label: "Blog", link: "/blog" },
          { label: "Contact Us", link: "/contactus" },
        ].map(({ label, link }) => (
          <Link 
          key={link} 
          to={link}
          onClick={() => setIsOpen(false)} >
        
            <li className="py-2 px-6 border-b font-[Nunito] border-gray-200 last:border-none text-gray-700 hover:text-blue-500 hover:bg-gray-100 cursor-pointer transition-colors duration-200">
              {label}
            </li>
          </Link>
        ))}
      </ul>
    </nav>
  );
};

export default Header;
